const Soon = () => (
  <button className="absolute top-3 right-3 z-10 flex cursor-default items-center gap-1 rounded-full !bg-[#F5FFFF] px-2.5 py-1 text-xs">
    Soon
  </button>
);

export default Soon;
